// SAFETY CHECK: Only let this script run once per page
if (!window.productInfoAccordionLoaded) {
  window.productInfoAccordionLoaded = true;

  document.addEventListener("DOMContentLoaded", function () {
    
    // --- 1. DESKTOP READ MORE LOGIC (Expands entire box) ---
    document.querySelectorAll(".product-info-box").forEach(box => {
      const deskBtn = box.querySelector(".js-desktop-readmore");
      const contents = box.querySelectorAll(".js-readmore-content");

      if (!deskBtn || deskBtn.dataset.initialized === "true") return;
      deskBtn.dataset.initialized = "true";

      let shouldShowDeskButton = false;

      requestAnimationFrame(() => {
        contents.forEach(content => {
          if (content.scrollHeight > content.clientHeight + 1) {
            shouldShowDeskButton = true;
          }
        });

        // If content is short, hide the button and auto-expand
        if (!shouldShowDeskButton) {
          box.classList.add("expanded");
          deskBtn.style.display = "none";
        }

        deskBtn.addEventListener("click", () => {
          box.classList.toggle("expanded");
          deskBtn.textContent = box.classList.contains("expanded") ? "Read less" : "Read more";
        });
      });
    });

    // --- 2. MOBILE READ MORE LOGIC (Expands individual columns) ---
    document.querySelectorAll(".mobile-readmore-group").forEach(group => {
      const mobBtn = group.querySelector(".js-mobile-readmore");
      const content = group.querySelector(".js-readmore-content");

      if (!mobBtn || !content || mobBtn.dataset.initialized === "true") return;
      mobBtn.dataset.initialized = "true";

      requestAnimationFrame(() => {
        if (content.scrollHeight <= content.clientHeight + 1) {
          group.classList.add("expanded");
          mobBtn.style.display = "none";
        }

        mobBtn.addEventListener("click", () => {
          group.classList.toggle("expanded");
          mobBtn.textContent = group.classList.contains("expanded") ? "Read less" : "Read more";
        });
      });
    });

    // --- 3. MOBILE MAIN ACCORDION LOGIC ---
    const accordionHeaders = document.querySelectorAll('.js-mobile-accordion-header');
    
    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        if (window.innerWidth < 990) {
          const container = this.closest('.js-mobile-accordion');
          const icon = this.querySelector('.mobile-accordion-icon');
          
          container.classList.toggle('is-open');
          
          if (icon) {
            icon.textContent = container.classList.contains('is-open') ? '-' : '+';
          }
        }
      });
    });

  });
}